import { render, staticRenderFns } from "./CidadaosVisitados.vue?vue&type=template&id=35388748"
import script from "./CidadaosVisitados.vue?vue&type=script&lang=js"
export * from "./CidadaosVisitados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports